import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { LandingPage } from "@/pages/LandingPage"
import { DemoSelectorPage } from "@/pages/DemoSelectorPage"
import { UploadPage } from "@/pages/UploadPage"
import { TemplateGalleryPage } from "@/pages/TemplateGalleryPage"
import { ChatPage } from "@/pages/ChatPage"

const basename = import.meta.env.BASE_URL.replace(/\/$/, '') || ''

function App() {
  return (
    <Router basename={basename}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/demo/select" element={<DemoSelectorPage />} />
        <Route path="/demo/upload" element={<UploadPage />} />
        <Route path="/demo/templates" element={<TemplateGalleryPage />} />
        <Route path="/demo/chat" element={<ChatPage />} />
      </Routes>
    </Router>
  )
}

export default App